export enum DBType {
MSSQL,
MYSQL_LIKE,
}
